import { render, staticRenderFns } from "./appGuide.vue?vue&type=template&id=2285866c&scoped=true&"
import script from "./appGuide.vue?vue&type=script&lang=js&"
export * from "./appGuide.vue?vue&type=script&lang=js&"
import style0 from "./appGuide.vue?vue&type=style&index=0&id=2285866c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285866c",
  null
  
)

export default component.exports